export default __webpack_public_path__ + "static/media/nine.44417d6a.svg";